import TrackLoginEvent from '../ui/track-login-event';

export default function () {
    TrackLoginEvent.attachTo(document);
}
